import React from 'react';
import { Skeleton } from '@alfa-bank/newclick-composite-components/skeleton';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { platformAtom } from '../../atoms/platform/atom';

import styles from './index.module.css';

const skeletons = [0, 1, 2, 3, 4, 5];

export const Loader = () => {
    const platform = useAtomValue(platformAtom);

    return (
        <div className={styles.skeletons}>
            {skeletons.map((item) => (
                <Skeleton
                    key={item}
                    dataTestId='pool-skeleton'
                    className={cn(styles.skeleton, styles[platform])}
                    visible={true}
                />
            ))}
        </div>
    );
};
